@if (field && field.CustomSettings) {
    <cerrix-editor-viewer [value]="field.CustomSettings"></cerrix-editor-viewer>
}
